import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
const AsyncWhatsAppImagePreview = Loadable({
  loader: () => import( /* webpackChunkName: "whatsapp-image-preview" */'./Preview/WhatsAppImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('whatsapp-image-preview')),
  LoadingComponent: () => null
});
export default AsyncWhatsAppImagePreview;